(app => {

    app.controller("addCaseController", addCaseController);

    function addCaseController($state, $mdDialog, _formPattern, caseApi, clientApi) { 
        const $ctrl = this;

        $ctrl.$onInit = () => {
            $ctrl.case = {
                ClientId: $ctrl.client.Id,
                Client: $ctrl.client,
            };

            $ctrl.formPattern = _formPattern;
        }

        $ctrl.close = () => {
            $mdDialog.hide();
        }

        $ctrl.searchClients = (term) => {
            return clientApi.searchClients(term).then(response => {
                return response;
            });
        }

        $ctrl.addCase = (ca) => {
            $ctrl.saving = true;

            caseApi.createCase(ca.ClientId, ca).then(response => {
                $state.go("Home.Client.Case", { clientId: ca.ClientId, caseId: response.Id }, {});

                $ctrl.close();
            });
        }
    }

})(window.app);